import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { Store } from '@ngrx/store';
import swal from 'sweetalert2';
import { AddEditPromoTypeComponent } from './addEditPromoType.component';

import * as fromRootStore from '../../../reducers';
import { PromoTypeService } from '../../../services/index';

@Component({
    selector: 'promo-type-tab',
    templateUrl: './promoType.component.html',
})
export class PromoTypeMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public user_type: string;
    public list: any[] = [];
    public promoTypeData: any[] = [];

    isLoadMask: Promise<any>;
    isLoading: boolean = false;
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    userType: string;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'promo_type',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    filterData = {
        "search_data": ""
    };

    constructor(
        public store: Store<fromRootStore.State>,
        private promoTypeService: PromoTypeService,
        private modalService: BsModalService,
        public toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Promo Type Name', prop: 'promo_type', width: 250, minWidth: 250, maxWidth: 250 },
            { name: 'Status', prop: 'status', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Action', prop: 'sno', width: 105, minWidth: 105, maxWidth: 105, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
     * Called whenever the user changes page
     */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getPromoTypeList();
        }
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100);
    }

    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);
    }

    getPromoTypeList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };

        let that = this;
        this.isLoadMask = this.promoTypeService
            .getPromoTypeList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.promoTypeData = res.data;
                that.userType = res.userType;
            });
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getPromoTypeList();
    }

    bsModalRef: BsModalRef;
    public onAddEditPromoType(mode: string, row: any, userType: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditPromoTypeComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Promo Type';
        this.bsModalRef.content.userType = userType;
        this.bsModalRef.content.promoTypeData = Object.assign({}, row);
        this.bsModalRef.content.promoTypeLoadEvent.subscribe(($e) => {
            that.getPromoTypeList();
        });
    }

    onDeletePromoType(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Promo Type: ' + row.promo_type + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.promoTypeService
                .deletePromoType({ promo_type_id: row.promo_type_id })
                .then(function(res: any) {
                    if (res.success) {
                        that.getPromoTypeList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });
        }, function(dismiss) {

        });
    }

    clearFilter(): void {
        this.filterData = { "search_data": "" };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.getPromoTypeList();
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/promoType/promoType.component.ts